import { lazy, Suspense, type ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const About = lazy(() => import("../pages/about/page"));
const Doctors = lazy(() => import("../pages/doctors/page"));
const DoctorDetail = lazy(() => import("../pages/doctors/doctorDetail"));
const Services = lazy(() => import("../pages/services/page"));
const ServiceDetail = lazy(() => import("../pages/services/serviceDetail"));
const CategoryPage = lazy(() => import("../pages/services/CategoryPage"));
const Gallery = lazy(() => import("../pages/gallery/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const BlogDetail = lazy(() => import("../pages/blog/blogDetail"));
const Appointment = lazy(() => import("../pages/appointment/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const Legal = lazy(() => import("../pages/legal/Legal"));

function PageLoader({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-background-50 flex items-center justify-center">
          <span className="w-10 h-10 rounded-full border-2 border-secondary-200 border-t-secondary-500 animate-spin" />
        </div>
      }
    >
      {children}
    </Suspense>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <PageLoader><Home /></PageLoader> },
      { path: "about", element: <PageLoader><About /></PageLoader> },
      { path: "doctors", element: <PageLoader><Doctors /></PageLoader> },
      { path: "doctors/:slug", element: <PageLoader><DoctorDetail /></PageLoader> },
      { path: "services", element: <PageLoader><Services /></PageLoader> },
      { path: "services/:category/:slug", element: <PageLoader><ServiceDetail /></PageLoader> },
      { path: "services/:category", element: <PageLoader><CategoryPage /></PageLoader> },
      { path: "gallery", element: <PageLoader><Gallery /></PageLoader> },
      { path: "blog", element: <PageLoader><Blog /></PageLoader> },
      { path: "blog/:slug", element: <PageLoader><BlogDetail /></PageLoader> },
      { path: "appointment", element: <PageLoader><Appointment /></PageLoader> },
      { path: "contact", element: <PageLoader><Contact /></PageLoader> },
      { path: "privacy-policy", element: <PageLoader><Legal type="privacy" /></PageLoader> },
      { path: "terms-and-conditions", element: <PageLoader><Legal type="terms" /></PageLoader> },
      { path: "medical-disclaimer", element: <PageLoader><Legal type="medical" /></PageLoader> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;